import { render, staticRenderFns } from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=template&id=62babfd7&scoped=true"
import script from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=style&index=0&id=62babfd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62babfd7",
  null
  
)

export default component.exports